import { PfsGameDto } from '@create-form/pfs-games/models/PfsGame.dto';
import { PfsGameType } from '@create-form/pfs-games/models/pfsGameType';
import { SavePfsGamesPayload } from '@create-form/pfs-games/pfs-games-modal/pfs-games-modal.component';
import { TierKeys } from '@create/Store/reducers/pfsGamesReducer';
import { Action } from '@ngrx/store';

export enum PfsGamesActionTypes {
  OPEN_PFS_GAMES_MODAL = '[Pfs Games] Open Pfs Games Modal',
  CLOSE_PFS_GAMES_MODAL = '[Pfs Games] Close Pfs Games Modal',

  FETCH_PFS_GAMES_REQUEST = '[Pfs Games] Fetch Pfs Games Request',
  FETCH_PFS_GAMES_SUCCESS = '[Pfs Games] Fetch Pfs Games Success',
  FETCH_PFS_GAMES_FAILURE = '[Pfs Games] Fetch Pfs Games Failure',

  SAVE_PFS_GAMES = '[Pfs Games] Save Pfs Games',

  DUPLICATE_PFS_GAMES = '[Pfs Games] Duplicate Pfs Games',

  RESET_PFS_GAMES = '[Pfs Games] Reset Pfs Games',
}

export class OpenPfsGamesModalAction implements Action {
  readonly type = PfsGamesActionTypes.OPEN_PFS_GAMES_MODAL;

  constructor(public payload: TierKeys) {
  }
}

export class ClosePfsGamesModalAction implements Action {
  readonly type = PfsGamesActionTypes.CLOSE_PFS_GAMES_MODAL;

  constructor(public payload: TierKeys) {
  }
}

export class FetchPfsGamesRequestAction implements Action {
  readonly type = PfsGamesActionTypes.FETCH_PFS_GAMES_REQUEST;

  constructor(public payload: { tierKey: symbol, betSize: number, gameType: PfsGameType, keepSavedGames?: boolean }) {
  }
}

export class FetchPfsGamesSuccessAction implements Action {
  readonly type = PfsGamesActionTypes.FETCH_PFS_GAMES_SUCCESS;

  constructor(public payload: { tierKey: symbol, games: PfsGameDto[], keepSavedGames?: boolean }) {
  }
}

export class FetchPfsGamesFailureAction implements Action {
  readonly type = PfsGamesActionTypes.FETCH_PFS_GAMES_FAILURE;

  constructor(public payload: { error: Error }) {
    console.error(payload.error);
  }
}

export class SavePfsGamesAction implements Action {
  readonly type = PfsGamesActionTypes.SAVE_PFS_GAMES;

  constructor(public payload: SavePfsGamesPayload) {
  }
}

export class DuplicatePfsGamesAction implements Action {
  readonly type = PfsGamesActionTypes.DUPLICATE_PFS_GAMES;

  constructor(public payload: { oldTiers: symbol[], newTiers: TierKeys[] }) {
  }
}

export class ResetPfsGamesAction implements Action {
  readonly type = PfsGamesActionTypes.RESET_PFS_GAMES;
}

export type PfsGamesActions = OpenPfsGamesModalAction | ClosePfsGamesModalAction
  | FetchPfsGamesRequestAction | FetchPfsGamesSuccessAction | FetchPfsGamesFailureAction
  | SavePfsGamesAction | DuplicatePfsGamesAction | ResetPfsGamesAction;
